<template>
  <div class="invitation-accept">
    Accepting invitation&hellip;
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAuth0 } from '@auth0/auth0-vue';

const route = useRoute();
const router = useRouter();
const { loginWithRedirect } = useAuth0();

onMounted(() => {
  const { invitation, organization } = route.query;

  if (invitation && organization) {
    loginWithRedirect({
      authorizationParams: { invitation, organization },
      appState: { target: '/console/getstarted' },
    });
  } else {
    router.replace('/');
  }
});
</script>

<style scoped>
.invitation-accept {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-size: 1.2rem;
  color: #fff;
}
</style>
